import ContactForm from "../../../../src/pages/ContactForm.jsx";
import * as React from 'react';
export default {
  ContactForm,
  React
};